import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=270a3e59"
import script from "./Interview.vue?vue&type=script&lang=js"
export * from "./Interview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports